import React, { PureComponent } from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  BarChart,
  Bar,
  CartesianGrid,
  Treemap,
  LineChart,
  Line,
  AreaChart,
  Area,
  Cell,
  XAxis,
  YAxis,
  Tooltip
} from "recharts";

import numeral from "numeral";

import { CHART_TYPES } from "containers/Report/ReportReducer";

import { graphSort } from "containers/Gallery/GalleryReducer";

import styles from "./style.module.css";

const numberFormatParams = {
  shortFormat: true,
  shortFormatMinValue: 0,
  precision: 1,
  justification: "L"
};

const CustomToolTip = (props) => {
  const { active, payload, unit, isCurrencyUnit } = props;
  if (!active || !payload) {
    return null;
  }

  const dataKey = payload[0] && payload[0].dataKey;
  const retPayload = payload[0] && payload[0].payload;

  if (!retPayload) {
    return null;
  }

  return (
    <div className={styles.cTooltip} style={{ fontSize: "14px", color: "#333" }}>
      <div>
        <strong>{retPayload.label}</strong>
      </div>
      <div>
        {isCurrencyUnit ? <span>{unit}</span> : <span />}
        {numeral(retPayload[dataKey]).format("0,0.[0]")}
        {!isCurrencyUnit ? <span style={{ marginLeft: "5px" }}>{unit}</span> : <span />}
      </div>
    </div>
  );
};

export default class OutcomeChart extends PureComponent {
  renderCorrelation(style) {
    const { isSmall, field, dataset, outcome } = this.props;

    const correlation =
      field &&
      outcome &&
      dataset &&
      dataset.fields &&
      dataset.fields[outcome] &&
      dataset.fields[outcome].leakage_info &&
      dataset.fields[outcome].leakage_info[field.label] &&
      dataset.fields[outcome].leakage_info[field.label]["Abs Correlation"] !== undefined
        ? dataset.fields[outcome].leakage_info[field.label]["Abs Correlation"]
        : field.correlation;

    return correlation === undefined ? (
      <div />
    ) : !isSmall && dataset && field && field.label === outcome ? (
      <div className={styles.cBarOuter} style={{ fontSize: "18px", bottom: "10px" }}>
        <div className={styles.badge}>{"EVALUATING"}</div>
      </div>
    ) : (
      <div className={styles.cBarOuter}>
        {!isSmall && (
          <div className={styles.boldItem} style={{ textAlign: "left" }}>
            {"Correlation with " + outcome + ": " + (correlation * 100).toFixed(2) + "%"}
          </div>
        )}
        <div className={!isSmall ? styles.cBarRight : styles.cBar} style={style ? style : {}}>
          <div
            className={
              styles.cBarInner +
              " " +
              (correlation !== undefined && correlation > 0.2 ? styles.cBarBad : styles.cBarGood)
            }
            style={{
              width: correlation * 100 + "%"
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      height,
      width,
      chart,
      showTitle,
      color,
      hideTitle,
      isSmall,
      isScaled,
      hideChart,
      field,
      dataset,
      outcome,
      outcomeSuccess,
      showCorrelation
    } = this.props;

    if (field === undefined) {
      return <div />;
    }

    if (field && field.outcomes && field.outcomes[outcome] && field.outcomes[outcome].values === undefined) {
      const retOutcomeSuccess = outcomeSuccess
        ? outcomeSuccess
        : Object.keys(field.outcomes[outcome]).filter((t) => t !== "table")[0];

      const oKey = retOutcomeSuccess;
      const oNotKey = "Not " + retOutcomeSuccess;

      const rawData =
        field && field.outcomes && field.outcomes[outcome] && field.outcomes[outcome][retOutcomeSuccess]
          ? Object.keys(field.outcomes[outcome][retOutcomeSuccess]).map((m, i) => ({
              [oKey]: Number(Number(field.outcomes[outcome][retOutcomeSuccess][m].percent) * 100),
              [oNotKey]: Number(Number(field.outcomes[outcome][retOutcomeSuccess][m].isNotOutcome).toFixed(2)),
              [field.label]: m,
              name: m,
              count: 0
            }))
          : [];

      const data = graphSort(rawData, field.label);

      return (
        <div className={styles.outcomeChart}>
          {(isSmall !== true || showTitle === true) && hideTitle !== true && (
            <div className={styles.boldItem} style={{ width: "100%", textAlign: "center" }}>
              {outcome + ": " + oKey + " by " + field.label}
            </div>
          )}
          {hideChart !== true && (
            <ResponsiveContainer>
              {chart && chart.chartType === CHART_TYPES.TREEMAP ? (
                <Treemap
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={oKey}
                  fill={color}
                  stroke={"#fff"}
                >
                  <Tooltip />
                </Treemap>
              ) : chart && chart.chartType === CHART_TYPES.LINE ? (
                <LineChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={oKey}
                  fill={"#63C7FF"}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <YAxis dataKey={oKey} type={"number"} domain={[0, "dataMax"]} unit="%" />
                  <XAxis dataKey={"name"} type={"category"} />
                  <Tooltip />
                  <Line type="monotone" dataKey={oKey} stroke={color} />
                </LineChart>
              ) : chart && chart.chartType === CHART_TYPES.AREA ? (
                <AreaChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={oKey}
                  fill={"#63C7FF"}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <YAxis dataKey={oKey} type={"number"} domain={[0, "dataMax"]} unit="%" />
                  <XAxis dataKey={"name"} type={"category"} />
                  <Tooltip />
                  <Area type="monotone" dataKey={oKey} stroke={color} />
                </AreaChart>
              ) : chart && chart.chartType === CHART_TYPES.PIE ? (
                <PieChart
                  margin={{
                    top: 10,
                    right: 10,
                    bottom: 10,
                    left: 10
                  }}
                >
                  <Tooltip />
                  <Pie data={data} dataKey={oKey} fill={color} label={(e) => e.name} />
                </PieChart>
              ) : (
                <BarChart
                  data={data}
                  margin={
                    isSmall ? { top: 10, bottom: 10, right: 10, left: 10 } : { top: 10, right: 40, bottom: 0, left: 10 }
                  }
                >
                  {isSmall !== true && <CartesianGrid strokeDasharray="3 3" />}
                  <XAxis
                    dataKey={field.label}
                    label={{
                      value: field.label,
                      position: "insideBottom",
                      offset: 0
                    }}
                    hide={isSmall ? true : false}
                  />
                  <YAxis
                    dataKey={oKey}
                    label={{
                      value: outcome,
                      position: "insideLeft",
                      angle: -90
                    }}
                    unit="%"
                    hide={isSmall ? true : false}
                    domain={isScaled ? [0, 1] : ["auto", "auto"]}
                  />
                  <Tooltip
                    cursor={{ strokeDasharray: "3 3" }}
                    formatter={(value, name, props) => Number(value).toFixed(2) + "%"}
                  />
                  <Bar dataKey={oKey}>
                    {data.map((p, index) => (
                      <Cell key={index} fill={color ? color : "#7E69D7"} />
                    ))}
                  </Bar>
                </BarChart>
              )}
            </ResponsiveContainer>
          )}
          {isSmall && showCorrelation && this.renderCorrelation()}
        </div>
      );
    } else if (
      field &&
      field.outcomes &&
      field.outcomes[outcome] &&
      field.outcomes[outcome].values !== undefined &&
      Array.isArray(field.outcomes[outcome].values) &&
      field.data
    ) {
      const rawData = field.outcomes[outcome].values
        .map((m, i) => ({
          [outcome]: Number(Number(m).toFixed(2)),
          [field.label]: field.data[i] ? field.data[i].value : "",
          name: field.data[i] ? field.data[i].value : undefined,
          count: 0
        }))
        .filter((d) => d.name !== undefined);

      const data = graphSort(rawData, field.label);

      console.log(this.props);

      return (
        <div className={styles.outcomeChart}>
          {(isSmall !== true || showTitle === true) && hideTitle !== true && (
            <div className={styles.boldItem} style={{ width: "100%", textAlign: "center" }}>
              {outcome + " by " + field.label}
            </div>
          )}
          {hideChart !== true && (
            <ResponsiveContainer>
              {chart && chart.chartType === CHART_TYPES.TREEMAP ? (
                <Treemap
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={outcome}
                  fill={"#7E69D7"}
                  stroke={"#fff"}
                >
                  <Tooltip />
                </Treemap>
              ) : chart && chart.chartType === CHART_TYPES.LINE ? (
                <LineChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={outcome}
                  fill={"#7E69D7"}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <YAxis dataKey={outcome} type={"number"} domain={[0, "dataMax"]} />
                  <XAxis dataKey={"name"} type={"category"} />
                  <Tooltip />
                  <Line type="monotone" dataKey={outcome} stroke="#7E69D7" />
                </LineChart>
              ) : chart && chart.chartType === CHART_TYPES.AREA ? (
                <AreaChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                  data={data}
                  dataKey={outcome}
                  fill={"#7E69D7"}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <YAxis dataKey={outcome} type={"number"} domain={[0, "dataMax"]} />
                  <XAxis dataKey={"name"} type={"category"} />
                  <Tooltip />
                  <Area type="monotone" dataKey={outcome} stroke="#7E69D7" />
                </AreaChart>
              ) : chart && chart.chartType === CHART_TYPES.PIE ? (
                <PieChart
                  margin={{
                    top: 10,
                    right: 10,
                    bottom: 10,
                    left: 10
                  }}
                  label={(e) => e.name}
                >
                  <Tooltip />
                  <Pie data={data} dataKey={outcome} fill={"#7E69D7"} label />
                </PieChart>
              ) : (
                <BarChart
                  data={data}
                  margin={
                    isSmall ? { top: 10, bottom: 10, right: 10, left: 10 } : { top: 10, right: 40, bottom: 0, left: 10 }
                  }
                >
                  {isSmall !== true && <CartesianGrid strokeDasharray="3 3" />}
                  <XAxis
                    dataKey={field.label}
                    label={{
                      value: field.label,
                      position: "insideBottom",
                      offset: 0
                    }}
                    hide={isSmall ? true : false}
                  />
                  <YAxis
                    dataKey={outcome}
                    label={{
                      value: outcome,
                      position: "insideLeft",
                      angle: -90
                    }}
                    hide={isSmall ? true : false}
                    domain={["auto", "auto"]}
                  />
                  <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                  <Bar dataKey={outcome}>
                    {data.map((p, index) => (
                      <Cell key={index} fill={"#7E69D7"} />
                    ))}
                  </Bar>
                </BarChart>
              )}
            </ResponsiveContainer>
          )}
          {isSmall && showCorrelation && this.renderCorrelation()}
        </div>
      );
    } else {
      return (
        <div className={styles.outcomeChart}>
          {field.warnings && field.warnings.length ? (
            <div style={{ color: "#A4A6B7", textAlign: "center" }}>{"Not included due to quality issues"}</div>
          ) : (
            ""
          )}
          {isSmall && showCorrelation && this.renderCorrelation()}
        </div>
      );
    }
  }
}
